"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTION_ACCOUNT = exports.TRANSACTION_ACCOUNT_ALL = exports.INVOICE_GROUP = void 0;
exports.INVOICE_GROUP = 'ari:cloud:css-xp::xp/invoice-group';
exports.TRANSACTION_ACCOUNT_ALL = 'ari:cloud:css-xp::xp/transaction-account/all';
exports.TRANSACTION_ACCOUNT = 'ari:cloud:css-xp::xp/transaction-account/id';
